<template>
  <div>
    <!-- WHEN MENU SHOWN -->
    <div v-if="isMenu == 1">
      <!-- Sidebar Overlay -->
      <div id="sidebarOverlay" @click="sidebarClick1()" class="lg:hidden"></div>

      <!-- Sidebar -->
      <aside
        id="sidebar"
        :class="['bg-white border-r border-gray-100 flex flex-col justify-between h-screen fixed top-0 left-0 z-20 transition-all duration-300', 
                sidebarCollapsed ? 'w-20' : 'w-64']"
      >
        <div>
          <!-- Logo -->
          <div class="p-5 flex items-center gap-2 border-b border-gray-100">
            <div
              class="w-9 h-9 bg-blue-600 rounded-full flex items-center justify-center shadow-md overflow-hidden border border-white/60"
            >
              <img
                src="/images/favicon.png"
                alt="Logo"
                class="w-7 h-7 object-cover rounded-full border border-white/80"
              />
            </div>
            <h2
              v-if="!sidebarCollapsed"
              class="text-xl font-bold text-gray-800 transition-all duration-300"
            >
              analytcly.<span class="text-blue-600">ai</span>
            </h2>
          </div>

          <!-- User Sidebar -->
          <nav class="mt-3 space-y-1" v-if="ldata && ldata.type === 'user'">
            <a
              href="/"
              class="sidebar-link flex items-center px-5 py-2.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
            >
              <i class="ri-dashboard-line text-lg mr-3 opacity-80"></i>
              <span v-if="!sidebarCollapsed">Dashboard</span>
            </a>
            <a
              href="/my_websites"
              class="sidebar-link flex items-center px-5 py-2.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
            >
              <i class="ri-global-line text-lg mr-3 opacity-80"></i>
              <span v-if="!sidebarCollapsed">My Website</span>
            </a>

            <!-- NEW ITEMS -->
            <a
              href="/ai_assistant"
              class="sidebar-link flex items-center px-5 py-2.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
            >
              <i class="ri-robot-line text-lg mr-3 opacity-80"></i>
              <span v-if="!sidebarCollapsed">Analyse with AI</span>
            </a>

            <a
              href="/profile_settings"
              class="sidebar-link flex items-center px-5 py-2.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
            >
              <i class="ri-user-settings-line text-lg mr-3 opacity-80"></i>
              <span v-if="!sidebarCollapsed">Profile Settings</span>
            </a>

            <a
              href="/pricing"
              class="sidebar-link flex items-center px-5 py-2.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
            >
              <i class="ri-price-tag-3-line text-lg mr-3 opacity-80"></i>
              <span v-if="!sidebarCollapsed">Pricing</span>
            </a>
          </nav>

          <!-- Admin Sidebar -->
          <nav class="mt-3 space-y-1" v-if="ldata && ldata.type === 'admin'">
            <a
              href="/home1"
              class="sidebar-link flex items-center px-5 py-2.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
            >
              <i class="ri-dashboard-line text-lg mr-3 opacity-80"></i>
              <span v-if="!sidebarCollapsed">Dashboard</span>
            </a>

            <a
              href="/all_customers"
              class="sidebar-link flex items-center px-5 py-2.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
            >
              <i class="ri-team-line text-lg mr-3 opacity-80"></i>
              <span v-if="!sidebarCollapsed">All Customers</span>
            </a>

            <a
              href="/pricing_list"
              class="sidebar-link flex items-center px-5 py-2.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
            >
              <i class="ri-money-dollar-circle-line text-lg mr-3 opacity-80"></i>
              <span v-if="!sidebarCollapsed">Plans</span>
            </a>
          </nav>
        </div>

        <!-- Logout -->
        <div class="p-5 border-t border-gray-100">
          <button
            @click="logoutNow"
            class="w-full flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg font-medium shadow-sm hover:bg-blue-700 hover:shadow-md transition-all"
          >
            <i class="ri-logout-circle-r-line text-lg"></i>
            <span v-if="!sidebarCollapsed">Logout</span>
          </button>
          <p v-if="!sidebarCollapsed" class="text-xs text-gray-400 text-center mt-3">
            © 2025 analytcly
          </p>
        </div>
      </aside>

      <!-- Main Layout -->
      <div
        class="flex-1 flex flex-col min-h-screen overflow-x-hidden min-w-0 relative z-0"
        :class="sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'"
      >
        <!-- Header -->
        <header
          class="bg-white border-b border-gray-100 px-6 py-3 flex justify-between items-center fixed top-0 left-0 right-0 z-10"
          :class="sidebarCollapsed ? 'lg:left-20' : 'lg:left-64'"
        >
          <div class="flex items-center gap-3">
            <button id="toggleSidebar" @click="sidebarClick" class="lg:hidden text-gray-500 hover:text-blue-600">
              <i class="ri-menu-line text-xl"></i>
            </button>

            <!-- Collapse Button -->
            <button
              @click="toggleCollapse"
              class="hidden lg:flex items-center text-gray-500 hover:text-blue-600 transition"
              title="Collapse Sidebar"
            >
              <i :class="sidebarCollapsed ? 'ri-arrow-right-s-line text-xl' : 'ri-arrow-left-s-line text-xl'"></i>
            </button>
          </div>

          <!-- Membership Details (unchanged) -->
          <div
            v-if="ldata!=null && ldata.type==='user'"
            class="flex items-center gap-4 bg-blue-50 border border-blue-100 rounded-xl px-4 py-2 shadow-sm hover:shadow transition-all"
          >
            <div class="flex items-center gap-2">
              <div class="bg-blue-600 text-white rounded-full w-9 h-9 flex items-center justify-center">
                <i class="ri-vip-crown-line text-lg"></i>
              </div>
              <div>
                <p class="font-semibold text-gray-800 leading-tight">{{ ldata.user_plan_name }}</p>
                <p v-if="ldata.mem==='1'" class="text-xs text-gray-500">
                  {{ ldata.mem1 }} days left • {{ ldata.user_plan_client }} Sites
                </p>
                <p v-if="ldata.mem==='0'" class="text-xs text-gray-500">Expired • 0 Sites</p>
                <p v-if="ldata.mem==='2'" class="text-xs text-gray-500">
                  Exceed limit • {{ ldata.user_plan_client }} Sites
                </p>
              </div>
            </div>

            <button
              @click="goToUpgrade"
              class="ml-3 px-3 py-1.5 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition shadow-sm"
            >
              Upgrade
            </button>
          </div>
        </header>

        <!-- Main Content -->
        <main class="flex-1 p-8 space-y-8 mt-16 overflow-x-hidden min-w-0">
          <router-view></router-view>
        </main>

        <footer class="bg-white border-t border-gray-100 px-6 py-3 text-sm text-gray-500 text-center">
          © 2025 analytcly
        </footer>
      </div>
    </div>

    <!-- WHEN MENU IS HIDDEN -->
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { getMyDt } from "@/apis/webapis";
export default {
  name: "App",
  data() {
    return {
      isMenu: 1,
      ldata: null,
      showLogoutDialog: false,
      sidebarCollapsed: false, // ✅ New state
    };
  },
  mounted() {
    const lastSegment = window.location.pathname.split("/");
    if (lastSegment[lastSegment.length - 1] === "login") {
      this.isMenu = 0;
      document.getElementById("app").className = "";
    } else {
      this.isMenu = 1;
      document.getElementById("app").className =
        "flex bg-gray-50 overflow-x-hidden w-full";
    }

    if (sessionStorage.getItem("ldata")) {
      try {
        this.ldata = JSON.parse(sessionStorage.getItem("ldata"));
        this.getMyDt1();
      } catch (e) {
        sessionStorage.removeItem("ldata");
      }
    } else {
      this.isMenu = 0;
      document.getElementById("app").className = "";
    }
  },
  methods: {
    async getMyDt1() {
      try {
        const res = await getMyDt(this.ldata.user_id);
        if (res.status && res.user_dt) {
          this.ldata = res.user_dt;
          sessionStorage.setItem("ldata", JSON.stringify(this.ldata));
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    goToUpgrade() {
      this.$router.push("/pricing");
    },
    toggleCollapse() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
    sidebarClick() {
      const sidebar = document.getElementById("sidebar");
      const sidebarOverlay = document.getElementById("sidebarOverlay");
      sidebar.classList.toggle("active");
      sidebarOverlay.classList.toggle("active");
    },
    sidebarClick1() {
      const sidebar = document.getElementById("sidebar");
      const sidebarOverlay = document.getElementById("sidebarOverlay");
      sidebar.classList.remove("active");
      sidebarOverlay.classList.remove("active");
    },
    logoutNow() {
      sessionStorage.removeItem("ldata");
      this.showLogoutDialog = false;
      setTimeout(() => {
        window.location.href = "/login";
      }, 300);
    },
  },
};
</script>

<style>
/* === GLOBAL WIDTH + LAYOUT FIX === */
html,
body,
#app {
  width: 100%;
  max-width: 100vw; /* prevent overshoot beyond viewport */
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  display: block;
  font-family: "Plus Jakarta Sans", sans-serif;
  background-color: #f9fafb;
  color: #111827;
  height: 100%; /* added to allow full viewport handling */
  overflow-y: hidden; /* prevent global scroll */
}

main {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding-left: 2rem;
  padding-right: 2rem;
  box-sizing: border-box;
  flex: 1 1 auto;
  overflow-y: auto; /* make only main scrollable */
  height: calc(100vh - 4rem); /* adjust for header height */
  padding-bottom: 1rem;
}

/* Prevent flex shrink and force proper layout alignment */
.flex-1,
.w-full,
.min-w-0 {
  min-width: 0; /* corrected: prevent flex overflow */
}

/* === FIXED LAYOUT ELEMENTS === */
.flex-1.lg\:ml-64 {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}

#sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  overflow-y: auto;
}

footer {
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

/* === RESPONSIVE PADDING === */
@media (max-width: 1024px) {
  main {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
}

@media (max-width: 640px) {
  main {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }
}
</style>


